import Axios from 'axios'

export default {
  namespaced: true,
  state: {
    fixtures: null,
    savePredictionResponse: null,
    userStatus: null,
    saveResultsResponse: null
  },
  getters: {
    FIXTURES: state => state.fixtures,
    SAVE_PREDICTION_RESPONSE: state => state.savePredictionResponse,
    USER_STATUS: state => state.userStatus,
    SAVE_RESULTS_RESPONSE: state => state.saveResultsResponse
  },
  mutations: {
    SET_FIXTURES: (state, payload) => {
      state.fixtures = payload
    },
    SET_SAVE_PREDICTION_RESPONSE: (state, payload) => {
      state.savePredictionResponse = payload
    },
    SET_USER_STATUS: (state, payload) => {
      state.userStatus = payload
    },
    SET_SAVE_RESULTS_RESPONSE: (state, payload) => {
      state.saveResultsResponse = payload
    }
  },
  actions: {
    FETCH_FIXTURES: async context => {
      try {
        const response = await Axios.get(`/football/fixtures/next-week`)
        context.commit('SET_FIXTURES', response.data)
      } catch (error) {
        context.commit('SET_FIXTURES', error.response.data)
      }
    },
    SAVE_PREDICTION: async (context, payload) => {
      try {
        const response = await Axios.post('/football/prediction/', payload)
        context.commit('SET_SAVE_PREDICTION_RESPONSE', response.data)
      } catch (error) {
        context.commit('SET_SAVE_PREDICTION_RESPONSE', error.response.data)
      }
    },
    FETCH_USER_STATUS: async context => {
      try {
        const response = await Axios.get(`/football/user-status`)
        context.commit('SET_USER_STATUS', response.data)
      } catch (error) {
        context.commit('SET_USER_STATUS', error.response.data)
      }
    },

    FETCH_RESULTS: async context => {
      try {
        const response = await Axios.get(`/football/result-save`)
        context.commit('SET_FIXTURES', response.data)
      } catch (error) {
        context.commit('SET_FIXTURES', error.response.data)
      }
    },
    SAVE_RESULTS: async (context, payload) => {
      try {
        const response = await Axios.post('/football/result-save', payload)
        context.commit('SAVE_RESULTS_RESPONSE', response.data)
      } catch (error) {
        context.commit('SAVE_RESULTS_RESPONSE', error.response.data)
      }
    }
  }
}
